import React, { type PropsWithChildren } from 'react';
import { Flex, theme } from 'antd';

/** The tinted box around a page's main filter controls. */
function FilterBar({ children }: PropsWithChildren) {
  const { token } = theme.useToken();

  return (
    <Flex
      gap={token.marginXS}
      align="flex-start"
      wrap
      style={{
        background: token.colorSuccessBg,
        border: `${token.lineWidth}px ${token.lineType} ${token.colorBorder}`,
        borderRadius: token.borderRadiusLG,
        padding: token.paddingXS,
      }}
    >
      {children}
    </Flex>
  );
}

export default FilterBar;
